export const getters = {
    getNotificacoes : state => state.notificacoes
}

export default {}